import { cn } from '../../utils/utils';

/**
 * A horizontal rule, optionally interrupted by a label.
 *
 * Extracted from the auth form's "OR" rule between the password form and the
 * magic link. Two lines and a centred cap rather than a bordered box, so the
 * label sits ON the rule instead of above it.
 *
 * The label is `font-mono text-eyebrow uppercase` - the repo's metadata face.
 * `JetBrains Mono` is for labels, metadata and numerals; see the workspace
 * design notes.
 */
export function Divider({
  label,
  className,
}: {
  label?: string;
  className?: string;
}) {
  if (!label) {
    return <hr className={cn('border-border border-0 border-t', className)} />;
  }

  return (
    <div className={cn('flex items-center gap-3', className)}>
      <span className='bg-border h-px flex-1' />
      <span className='text-eyebrow text-muted-foreground font-mono uppercase'>
        {label}
      </span>
      <span className='bg-border h-px flex-1' />
    </div>
  );
}
